"use client";

import { AuthProvider } from "@/lib/context/Auth";
import { PermissionsProvider } from "@/lib/context/Permissions";
import { PreferencesProvider } from "./context/Preferences";
import { PageMetadataProvider } from "@/components/dashboard/Breadcrumbs/PageMetadataContext";
export function Providers({
  children
}: {
  children: React.ReactNode;
}) {
  return <AuthProvider data-sentry-element="AuthProvider" data-sentry-component="Providers" data-sentry-source-file="Providers.tsx">
      <PreferencesProvider data-sentry-element="PreferencesProvider" data-sentry-source-file="Providers.tsx">
        <PageMetadataProvider data-sentry-element="PageMetadataProvider" data-sentry-source-file="Providers.tsx">
          <PermissionsProvider data-sentry-element="PermissionsProvider" data-sentry-source-file="Providers.tsx">{children}</PermissionsProvider>
        </PageMetadataProvider>
      </PreferencesProvider>
    </AuthProvider>;
}